/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useState } from "react";
import { useSelector } from "react-redux";
import { CurrentUser, FamilyHasAccess, SelectableItem2, UserItem } from "../types";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../components/Inputs/Dropdown";
import { Features } from "../constants";
import MyProfile from "../components/Settings/MyProfile";
import MyEmailAddresses from "../components/Settings/MyEmailAddresses";
import FamilySettings from "../components/Settings/FamilySettings";
import FamilyBuckets from "../components/Settings/FamilyBuckets";
import FamilyTimeframes from "../components/Settings/FamilyTimeframes";
import FamilyAccounts from "../components/Settings/FamilyAccounts";

const Settings = () => {
	const user: CurrentUser = useSelector((state: any) => state.userData.value);

	const navigate = useNavigate();
	const users: UserItem[] = useSelector((state: any) => state.users.value);

	const location = useLocation();
	const page = location.pathname.toLowerCase().substring(location.pathname.lastIndexOf("/") + 1);
	if (page === "settings") navigate("/Settings/Profile");

	const me = users?.find(u => u.isMe);
	const setting = {
		FirstName: me?.firstName,
		LastName: me?.lastName,
		Email: user.email,
		Password: '',
		ConfirmPassword: '',
		Rate: user.mileageRate,
		AllowUnassigned: user.unassignedBudgets,
		IncludeAllUsersInBudgets: user.includeAllUsersInBudgets,
		FamilyName: user.familyName
	};
	const [settings, setSettings] = useState(setting);
	if (settings.FirstName !== setting.FirstName && !settings.FirstName) {
		const me = users?.find(u => u.isMe);
		const s = {
			...settings,
			FirstName: me?.firstName,
			LastName: me?.lastName,
		};
		setSettings({ ...s });
	}

	const useEmail = FamilyHasAccess(user, Features.UserEmails);
	const useTimeframes = user.isHoH && user.isActive && FamilyHasAccess(user, Features.Timeframes);
	const useAccounts = user.isHoH && user.isActive && FamilyHasAccess(user, Features.Accounts);

	const sections: SelectableItem2[] = [
		{ Id: "profile", Value: 'My Profile' }
	];
	if (useEmail) {
		sections.push({ Id: "emails", Value: 'My Email Addresses' });
	}
	if (user.isHoH) {
		sections.push({ Id: "family", Value: 'Family Settings' });
		sections.push({ Id: "labeldefinitions", Value: 'Label Definitions' });
		sections.push({ Id: "labeloptions", Value: 'Label Options' });
	}
	if (useTimeframes) {
		sections.push({ Id: "timeframes", Value: 'Family Timeframes' });
	}
	if (useAccounts) {
		sections.push({ Id: "accounts", Value: 'Family Accounts' });
	}

return (<>
	{users && user && <>
		<Dropdown Size={4}
			Class="mb-5 right"
			Variant="standard"
			Options={sections}
			Value={page}
			OnChange={SetSection} />
		{page === "profile" &&
			<MyProfile />
		}
		{page === "family" &&
			<FamilySettings />
		}
		{useEmail && page === "emails" &&
			<MyEmailAddresses />
		}
		{page === "labeloptions" &&
			<FamilyBuckets />
		}
		{useTimeframes && page === "timeframes" &&
			<FamilyTimeframes />
		}
		{useAccounts && page === "accounts" &&
			<FamilyAccounts />
		}
	</>}
</>);

	function SetSection(page: number) {
		navigate(`/Settings/${page}`);
	}
}

export default Settings;